import { List } from "@mui/material";
import React from "react";

import SidebarListItem from "./SidebarListItem";

const VIRTUALIZATION_THRESHOLD = 30;
const VIRTUALIZED_ROW_HEIGHT = 40;
const VIRTUALIZED_LIST_MAX_HEIGHT = 320;
const VIRTUALIZED_OVERSCAN_ROWS = 8;

function VirtualizedBoardList({ listing }) {
  const shouldVirtualize = listing.length > VIRTUALIZATION_THRESHOLD;
  const [scrollTop, setScrollTop] = React.useState(0);

  const handleScroll = React.useCallback((event) => {
    setScrollTop(event.currentTarget.scrollTop);
  }, []);

  React.useEffect(() => {
    setScrollTop(0);
  }, [listing]);

  if (!shouldVirtualize) {
    return (
      <List dense className="list-container">
        {listing.map((board) => (
          <SidebarListItem key={board.board_id} board={board} />
        ))}
      </List>
    );
  }

  const containerHeight = Math.min(
    listing.length * VIRTUALIZED_ROW_HEIGHT,
    VIRTUALIZED_LIST_MAX_HEIGHT
  );
  const visibleCount = Math.ceil(containerHeight / VIRTUALIZED_ROW_HEIGHT);
  const startIndex = Math.max(
    0,
    Math.floor(scrollTop / VIRTUALIZED_ROW_HEIGHT) - VIRTUALIZED_OVERSCAN_ROWS
  );
  const endIndex = Math.min(
    listing.length,
    startIndex + visibleCount + VIRTUALIZED_OVERSCAN_ROWS * 2
  );
  const visibleBoards = listing.slice(startIndex, endIndex);

  return (
    <div
      className="virtualized-board-list-scroll"
      style={{ height: containerHeight }}
      onScroll={handleScroll}
    >
      <List
        dense
        className="list-container virtualized-board-list"
        style={{ height: listing.length * VIRTUALIZED_ROW_HEIGHT }}
      >
        {visibleBoards.map((board, index) => (
          <SidebarListItem
            key={board.board_id}
            board={board}
            style={{
              position: "absolute",
              top: `${(startIndex + index) * VIRTUALIZED_ROW_HEIGHT}px`,
              left: 0,
              right: 0,
              width: "100%",
            }}
          />
        ))}
      </List>
    </div>
  );
}

export default React.memo(VirtualizedBoardList);
